<template>
    <v-container class="container--large">
        <div class="sub-top-image-wrap">
            <div class="sub-top-image" :style="'background-image:url('+ src +');'"></div>
        </div>
    </v-container>
</template>

<script>

export default{
    props : {
        src : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.sub-top-image-wrap{
    width: 100%;
    height: 0;
    padding-top: calc((400 / 1760) * 100%);
    position: relative;
    z-index: 0;
}
.sub-top-image{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
</style>